import React from 'react';
import * as pages from 'pages';

const AnalysisTab = () => {
  return (
    <>
      <pages.Inflow />
      <pages.Sales />
    </>
  );
};

export default AnalysisTab;
